import client from "./client";

const getAuditTrails = () => client.get("/subsidiary/dashboard/audit/trails");

export default { getAuditTrails };
